export default "__VITE_ASSET__yLfCl2qi__"